module.exports = __webpack_public_path__ + "img/jixiao_banner.cab12b81.png";